var _ = require("../uam/fields.module.js")(module.exports, {
  namespace: "email",
  title: "Email",
  description: "A field representing a valid email address.",
  type: "field",
  use: {
    namespace: "ua.input"
  },
  errors: {
    invalid: {
      title: "Invalid Email",
      description: "The value must be a valid email address.",
      template: "Invalid email: '${value}'"
    }
  },
  tests: {
    valid: {
      must: true,
      run: function() {
        return validate({}, "person@example.com");
      }
    },
    invalid: {
      throw: "fields.email.invalid",
      run: function() {
        return validate({}, "not-an-email");
      }
    }
  }
});

var verifyEmail = require("../uam/functions/verifyEmail.js").function;

function validate(spec, value) {
  var email = (value || "").toString().trim().toLowerCase();
  if (!(email) || !(verifyEmail(email))) {
    _.errors.invalid.throw({ value: value });
  }
}
module.exports.validate = validate;
